<template>
  <div class="highlighted highlighted--verhaal">
    <img 
      v-if="src" 
      :src="src"
      class="highlighted__image" />
    <div class="highlighted__content">
      <h3>
        <router-link :to="link">{{ title }}</router-link>
      </h3>
      <Link 
        :to="link"
        label="Bekijk het project" />
    </div>
  </div>
</template>

<script>
import Link from '@/components/Link';

export default {
  name: 'HighlightedVerhaal',
  components: {
    Link
  },
  props: {
    slug: {
      type: String,
      required: true
    }
  },
  computed: {
    projectData() {
      return this.$store.getters.getProjectBySlug({
        slug: this.slug
      });
    },
    title() {
      return this.projectData.name
    },
    src() {
      return (this.projectData.image) 
        ? this.projectData.image[0].url
        : false;
    },
    link() {
      return {
        name: 'project-beknopt',
        params: {
          slug: this.slug
        }
      }
    }
  }
}
</script>

<style lang="scss">

  .highlighted {
    &--verhaal {
      display: flex;
      flex-flow: row nowrap;
      align-items: flex-start;
      background: #eff3fa;
      padding: 16px;
      position: relative;
      width: 100%;
    }
    &__image {
      width: 130px;
      // display: flex;
      // flex-flow: row nowrap;
      // align-items: center;
      object-fit: contain;
      margin-right: 16px;
    }
    &__content {
      display: flex;
      flex-wrap: wrap;
      // flex-grow: 2;
      height: 100%;
      flex-direction: column;
      width: calc(100% - 146px);

      h3 {
        margin: 0 0 8px;
        font-family: $font_header;

        a {
          color: $black;
          text-decoration: none;
          &:hover {
            color: $metro_oranje;
          }
        }
      }
      p {
        line-height: 24px;
      }
    }
  }

</style>
